import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInputField = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.75 7.75h1.5a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2h-1.5m-7.5 0h-1.5a2 2 0 0 1-2-2v-4.5a2 2 0 0 1 2-2h1.5M10.75 4.75h2.5M10.75 19.25h2.5M12 5v14"
    />
  </svg>
);
export default SvgInputField;
